// ⬇️ 09-29 memory download (Nina: "build the download memories button"): an agent's
// owner takes its memory bank with them, e.g. to hand to another AI they run
// (a Quill owner asked to carry Quill's memories to their Opus). One readable
// Markdown file: a person can read it, and an AI can take it as notes.
// The list is what /api/agents/me?include_memories=1 returns: newest first,
// at most 200 rows (the route's own cap, said in the file when it is hit).

export const MEMORY_EXPORT_CAP = 200;

const SOURCE_TITLES = {
  imported: 'From your import',
  visit: 'Visits',
  expedition: 'Expeditions',
  knowledge_file: 'Knowledge files',
  space_play: 'Rooms',
  skill: 'Skills',
};

const SOURCE_ORDER = ['imported', 'knowledge_file', 'skill', 'visit', 'space_play', 'expedition'];

const dayOf = (ts) => {
  const t = Date.parse(ts || '');
  return Number.isFinite(t) ? new Date(t).toISOString().slice(0, 10) : '';
};

const oneLine = (s) => String(s == null ? '' : s).replace(/\s+/g, ' ').trim();

export function memoryFileName(name, now = new Date()) {
  const slug = oneLine(name).toLowerCase().replace(/[^a-z0-9]+/g, '-').replace(/^-+|-+$/g, '').slice(0, 40) || 'agent';
  return `${slug}-memories-${now.toISOString().slice(0, 10)}.md`;
}

export function memoriesToMarkdown(name, memories, now = new Date()) {
  const list = (Array.isArray(memories) ? memories : []).filter((m) => m && oneLine(m.content));
  const who = oneLine(name) || 'Your agent';
  const out = [
    `# ${who}'s memories (myspAIce)`,
    '',
    `Exported ${now.toISOString().slice(0, 10)}. ${list.length} memor${list.length === 1 ? 'y' : 'ies'}, newest first in each group.`,
    '🔒 private: only you and your agent see it. 🌍 public: can come up on stream. 🤫 known, but never brought up unasked.',
  ];
  if (list.length >= MEMORY_EXPORT_CAP) out.push(`This is the newest ${MEMORY_EXPORT_CAP}. Older memories are not in this file.`);
  if (!list.length) {
    out.push('', 'No memories yet.');
    return `${out.join('\n')}\n`;
  }
  const groups = new Map();
  for (const m of list) {
    const key = SOURCE_TITLES[m.source] ? m.source : (m.source || 'other');
    if (!groups.has(key)) groups.set(key, []);
    groups.get(key).push(m);
  }
  const keys = [...SOURCE_ORDER.filter((k) => groups.has(k)), ...[...groups.keys()].filter((k) => !SOURCE_ORDER.includes(k)).sort()];
  for (const k of keys) {
    const title = SOURCE_TITLES[k] || `${k.charAt(0).toUpperCase()}${k.slice(1).replace(/_/g, ' ')}`;
    out.push('', `## ${title}`, '');
    for (const m of groups.get(k)) {
      const marks = `${m.audience === 'streamable' ? '🌍' : '🔒'}${m.never_raise_unprompted ? ' 🤫' : ''}`;
      const day = dayOf(m.created_at);
      out.push(`- ${marks} ${oneLine(m.content)}${day ? ` (${day})` : ''}`);
    }
  }
  return `${out.join('\n')}\n`;
}
